import { render, staticRenderFns } from "./accountEditHR.vue?vue&type=template&id=4d472af2&scoped=true"
import script from "./accountEditHR.vue?vue&type=script&lang=js"
export * from "./accountEditHR.vue?vue&type=script&lang=js"
import style0 from "./accountEditHR.vue?vue&type=style&index=0&id=4d472af2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d472af2",
  null
  
)

export default component.exports